<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[{text: 'Home', disable: false, href: '/#/'}, {text: 'Greenhouses', disabled: false, href: '/#/greenhouses'}, {text: greenhouseName, disable: true}]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
        </v-row>

        <!-- Section growth tasks dialog -->
        <GreenhouseDepartmnetSectionTasksDialog
            :dialog.sync="sectionDetaildialog"
            :selectedSectionNodeId="selectedSectionNodeId"
        ></GreenhouseDepartmnetSectionTasksDialog>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-text>
                                <v-row class="ma-0">
                                    <v-col cols="8">
                                        <v-row>
                                            <v-col>
                                                Department:
                                                <h2>{{ greenhouseDepartment.name }}</h2>
                                            </v-col>
                                            <v-col>
                                                #Sectors:
                                                <h2>{{ sectors.length }}</h2>
                                            </v-col>
                                            <v-col>
                                                #Growth Tasks:
                                                <h2>{{ totalGrowthTasks }}</h2>
                                            </v-col>
                                            <v-col>
                                                #Plants:
                                                <h2>{{ totalPlants }}</h2>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="4" class="text-end">
                                        <v-progress-circular
                                            :rotate="0"
                                            :size="100"
                                            :width="15"
                                            :value="greenhouseDepartment.totalUsedRate * 100"
                                            color="teal"
                                        >{{ totalUsedRateInt }}%</v-progress-circular>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="ml-2 mr-2">dashboard</v-icon>Sectors
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        dense
                                        v-model="search"
                                        append-outer-icon="refresh"
                                        @click:append-outer="refreshCurrentPage()"
                                        label="Search"
                                        clearable
                                        hide-details
                                        @keydown.enter="refreshCurrentPage()"
                                        @click:clear="onClearSearch()"
                                    ></v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="$apollo.queries.greenhouseDepartment.loading"
                                    :items="sectors"
                                    :search="search"
                                    sortBy="node.name"
                                    loading-text="Loading... Please wait"
                                >
                                    <template v-slot:item.node.numTemplates="{ item }">
                                        <span
                                            v-if="item.node.numTemplates==0"
                                            class="error--text"
                                        >{{ item.node.numTemplates }}</span>
                                        <span v-else>{{ item.node.numTemplates }}</span>
                                    </template>
                                    <template v-slot:item.node.numProducts="{ item }">
                                        <span
                                            v-if="item.node.numProducts==0"
                                            class="error--text"
                                        >{{ item.node.numProducts }}</span>
                                        <span v-else>{{ item.node.numProducts }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="openPlantDialog(item.node)"
                                        >View</v-btn>-->
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="onSelectSector(item.node.id)"
                                        >
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import GreenhouseDepartmnetSectionTasksDialog from "@/components/greenhouse/GreenhouseDepartmentSectionTasksDialog.vue";
// import DeleteDialog from "@/components/base/DeleteDialog.vue";

export default {
    name: "greenhouse-department-page",
    components: {
        // DeleteDialog
        GreenhouseDepartmnetSectionTasksDialog
    },

    apollo: {
        greenhouseDepartment: {
            query: gql`
                query greenhouseDepartment($id: ID!) {
                    greenhouseDepartment(id: $id) {
                        id
                        name
                        totalUsedRate
                        totalUsedSpaceM2
                        greenhouse {
                            id
                            name
                        }
                        greenhouseDepartmentSectionSet(isPlaceholder: false) {
                            edges {
                                node {
                                    id
                                    name
                                    numPlants
                                    numGrowthTasks
                                    spaceM2
                                    usedSpaceM2
                                    usedRate
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    id: this.$route.params.id
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: (data) => data.greenhouseDepartment,
            skip: false,
            pollInterval: 60000 // ms

            // pollInterval: 300 // ms
        }
    },

    data: function () {
        return {
            // isLoadingPlantsTable: false,
            sectionDetaildialog: false,
            search: "",

            defaultItemsPerPage: 10,
            dataTableOptions: {},
            page: 1,

            greenhouseDepartment: {},

            selectedSectionNodeId: null,

            headers: [
                {
                    text: "Sector",
                    value: "node.name",
                    sortable: true
                },
                {
                    text: "Total Space (m2)",
                    value: "node.spaceM2",
                    sortable: true,
                    filterable: false
                },
                {
                    text: "Used Space (m2)",
                    value: "node.usedSpaceM2",
                    sortable: true,
                    filterable: false
                },
                {
                    text: "#Growth Tasks",
                    value: "node.numGrowthTasks",
                    sortable: true,
                    filterable: false
                },
                {
                    text: "#Plants",
                    align: "left",
                    value: "node.numPlants",
                    sortable: true,
                    filterable: false
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // plants: function() {
        //     return this.$store.state.plants.plants;
        // },
        // editedPlant: function() {
        //     if (this.editedIndex > -1) {
        //         return this.plants[this.editedIndex];
        //     } else {
        //         return null;
        //     }
        // }

        greenhouseName() {
            return this.greenhouseDepartment.greenhouse
                ? this.greenhouseDepartment.greenhouse.name
                : "";
        },

        sectors() {
            return this.greenhouseDepartment.greenhouseDepartmentSectionSet
                ? this.greenhouseDepartment.greenhouseDepartmentSectionSet.edges
                : [];
        },

        totalGrowthTasks() {
            var _numTasks = 0;

            if (this.greenhouseDepartment.greenhouseDepartmentSectionSet) {
                _numTasks = this.greenhouseDepartment.greenhouseDepartmentSectionSet.edges.reduce(
                    (a, b) => a + b.node.numGrowthTasks,
                    0
                );
            }
            return _numTasks;
        },

        totalPlants() {
            var _numPlants = 0;

            if (this.greenhouseDepartment.greenhouseDepartmentSectionSet) {
                _numPlants = this.greenhouseDepartment.greenhouseDepartmentSectionSet.edges.reduce(
                    (a, b) => a + b.node.numPlants,
                    0
                );
            }

            return _numPlants;
        },

        totalUsedRateInt() {
            return (
                Math.round(this.greenhouseDepartment.totalUsedRate * 100) || 0
            );
        }
    },
    watch: {
        // page(newValue, oldValue) {
        //     if (newValue > oldValue) {
        //         this.getNextPage();
        //     } else {
        //         this.getPrevPage();
        //     }
        // },
        // itemsPerPage() {
        //     this.refreshCurrentPage();
        // }
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        }
    },
    created() {
        // this.initialize();
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        // initialize() {
        //     // this.fetchPlants();
        // },

        // fetchPlants() {
        //     // fetch plants
        //     this.isLoadingPlantsTable = true;
        //     this.$store
        //         .dispatch("plants/fetchPlants")
        //         .then(() => {
        //             // console.log("Fetched plants");
        //             // this.snackbarText = `${this.plants.length} plants fetched!`;
        //             // this.snackbar = true;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingPlantsTable = false));
        // },

        refreshCurrentPage() {
            // set skip false to execute the query
            this.$apollo.queries.greenhouseDepartment.skip = false;
            this.$apollo.queries.greenhouseDepartment.refresh();
        },

        onSelectSector(sectorId) {
            this.selectedSectionNodeId = sectorId;
            this.sectionDetaildialog = true;
        }
    }
};
</script>